import { ReactElement } from 'react'
import { Button, Input } from '../../Atoms'
import { GreenInputFieldProps } from './props'
import { StyledGreenInputField } from './styles'

const GreenInputField = ({
    buttonDataCy,
    buttonDisabled = true,
    buttonText,
    onClickButton = () => undefined,
    showButton,
    ...props
}: GreenInputFieldProps): ReactElement => (
    <StyledGreenInputField showButton={showButton}>
        <Input {...props} type="text" />
        <Button
            data-cy={buttonDataCy}
            disabled={buttonDisabled}
            onClick={onClickButton}
            variant="success"
        >
            {buttonText}
        </Button>
    </StyledGreenInputField>
)

export default GreenInputField

export { StyledGreenInputField }
